import axios from 'axios';

const api = axios.create({
  baseURL: '/api',
  timeout: 15000,
});

// Admin token interceptor
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('mi_ispira_admin_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const getStats = () => api.get('/stats');
export const getBusinesses = (params) => api.get('/businesses', { params });
export const getFeatured = (limit = 6) => api.get('/businesses/featured', { params: { limit } });
export const getBusiness = (slug) => api.get(`/businesses/${slug}`);
export const getRelated = (slug, limit = 4) => api.get(`/businesses/${slug}/related`, { params: { limit } });
export const autocomplete = (q) => api.get('/search/autocomplete', { params: { q } });
export const getCategories = () => api.get('/categories');
export const getCategory = (slug) => api.get(`/categories/${slug}`);
export const getTopics = (limit = 30) => api.get('/topics', { params: { limit } });
export const getTopic = (slug) => api.get(`/topics/${slug}`);
export const getLocations = () => api.get('/locations');

// Admin
export const adminLogin = (email, password) => api.post('/admin/login', { email, password });
export const adminGetBusinesses = (params) => api.get('/admin/businesses', { params });
export const adminUpdateBusiness = (id, data) => api.put(`/admin/businesses/${id}`, data);
export const adminDeleteBusiness = (id) => api.delete(`/admin/businesses/${id}`);
export const adminSync = () => api.post('/admin/sync');
export const submitContact = (data) => api.post('/contact', data);
export const adminGetContacts = (params) => api.get('/admin/contacts', { params });
export const adminMarkContactRead = (id) => api.put(`/admin/contacts/${id}/read`);
export const adminDeleteContact = (id) => api.delete(`/admin/contacts/${id}`);
export const adminSyncStatus = () => api.get('/admin/sync/status');

export default api;
